/**
 * FAQ Accordion Component
 * Handles expand/collapse functionality for FAQ items
 */

class FaqAccordion {
  constructor(element) {
    this.element = element;
    this.buttons = this.element.querySelectorAll('.faq-accordion__question');
    this.init();
  }

  init() {
    this.buttons.forEach(button => {
      // Skip disabled buttons (questions without answers)
      if (button.disabled) return;

      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleItem(button);
      });
    });
  }

  toggleItem(button) {
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const answerId = button.getAttribute('aria-controls');
    const answer = document.getElementById(answerId);

    if (!answer) return;

    // Toggle current item (allows multiple items to be open)
    if (isExpanded) {
      button.setAttribute('aria-expanded', 'false');
      answer.classList.remove('is-open');
      setTimeout(() => {
        answer.hidden = true;
      }, 400);
    } else {
      button.setAttribute('aria-expanded', 'true');
      answer.hidden = false;
      // Force reflow to ensure transition happens
      answer.offsetHeight;
      answer.classList.add('is-open');
    }
  }
}

// Initialize all FAQ accordions on the page
function initFaqAccordions() {
  const accordions = document.querySelectorAll('.faq-accordion');
  accordions.forEach(accordion => {
    new FaqAccordion(accordion);
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFaqAccordions);
} else {
  initFaqAccordions();
}

export default FaqAccordion;
